export enum NavigationKey {
  // Main flow routes
  'welcome' = '',
  'accident-location' = 'accident-location',
  'accident-report-finished' = 'accident-report-finished',
  'accident-role' = 'accident-role',
  'active-ride' = 'active-ride',
  'alcohol-consumption' = 'alcohol-consumption',
  'car-parts-involved' = 'car-part-involved',
  'contact-validation' = 'contact-validation',
  'damage-type' = 'damage-type',
  'data-correctness-confirmation' = 'data-correctness-confirmation',
  'data-is-correct' = 'data-is-correct',
  'detail-accident-description' = 'incident-description-detail',
  'document-upload-overview' = 'document-upload-overview',
  'document-upload-police-report' = 'document-upload-police-report',
  'document-upload-finished' = 'document-upload-finished',
  'driver-age' = 'driver-age',
  'enter-license-plate' = 'enter-license-plate',
  'fault-allocation' = 'who-is-to-blame',
  'finish' = 'finish',
  'incident-description' = 'incident-description',
  'involved-vehicles' = 'involved-vehicles',
  'multiple-party-involvement' = 'multiple-party-involvement',
  'no-processing-possible' = 'no-processing-possible',
  'overview' = 'overview',
  'personal-information' = 'personal-information',
  'personal-information-finished' = 'personal-information-finished',
  'police-drug-test' = 'police-drug-test',
  'police-report' = 'police-report',
  'potential-technical-defect' = 'potential-technical-defect',
  'ride-information-finish' = 'ride-information-finish',
  'ride-reason' = 'ride-reason',
  'technical-issue' = 'technical-issue',
  'third-party-information' = 'third-party-information',
  'user-participation' = 'user-participation',
  'vehicle-accident-status' = 'vehicle-accident-status',
  'vehicle-involved' = 'vehicle-involved',
  'who-is-to-blame' = 'who-is-to-blame',
  'witness-details' = 'witness-details',
  'witness-information' = 'witness-information',

  // Disclaimer flow routes
  'insurance-information' = 'insurance-information',
  'claim-report-duty' = 'claim-report-duty',
  'quick-response-info' = 'quick-response-info',
  'what-is-covered' = 'what-is-covered',

  // Information pages
  'what-to-do' = 'what-to-do',
  'about-insurer' = 'about-insurer',
  'about-policyholder' = 'about-policyholder',
  'imprint' = 'imprint',
  'data-privacy' = 'data-privacy',
  'faq' = 'faq',

  // System routes
  'token-expired' = 'token-expired',
  'debug-routes' = 'debug-routes',
}
